import React, { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Form } from 'antd';

// Shared UI Library Components
// import { CustomButton, CustomTag, DropdownElement } from '@ppmcore/seven-ppm-core-shared-components-react';

// Store entities
import { updateCompanyCurrency } from '../../../../../../store/currency/currency.thunks';

// Styles
import './app-currency.scss';

// Models
import { ICurrency } from '../../../../../../interfaces/company.interfaces';

type TAppCurrencyProps = {
  currentCurrency: ICurrency;
  availableCurrencies: ICurrency[];
  loading?: boolean;
};

export const AppCurrency: FC<TAppCurrencyProps> = ({
  currentCurrency,
  availableCurrencies,
  loading = false
}: TAppCurrencyProps) => {
  const [form] = Form.useForm<{ currency: string }>();

  const [hasChanges, setHasChanges] = useState<boolean>(false);

  const dispatch = useDispatch<any>();

  const currencyOptions = availableCurrencies.map(curr => ({
    label: `${ curr.name } ${ curr.symbol }`,
    value: curr.name
  }));

  const onValuesChange = (_: { [key: string]: string | string[] }, { currency }: {
    currency: string,
  }): void => {
    const isHasChanges = currentCurrency.name !== currency;
    setHasChanges(isHasChanges);
  }

  const saveChanges = async (): Promise<void> => {
    const { currency } = form.getFieldsValue();

    const { payload } = await dispatch(updateCompanyCurrency(currency));

    if (!payload) return;
    setHasChanges(false);
    form.resetFields();
  }

  useEffect(() => {
    if (!currentCurrency) return;
    form.setFieldValue('currency', currentCurrency.name);
  }, [currentCurrency]);

  return (
    <div className="app-currency">
      <div className="app-currency--label business--label">
        <div className="label-title">
          App Currency
        </div>
      </div>
      <div className="app-currency--description business--description">
        {/*Select your preferred currency to receive payments from anywhere*/ }
        Main currency for all pricing and calculations, sourced from your Stripe account
      </div>
      { (!!availableCurrencies?.length && !!currentCurrency?.name) &&
        // <Form className="app-currency--body business--body-items" form={ form } onValuesChange={ onValuesChange }>
        //   <div className="body-item">
        //     <Form.Item name={ 'currency' } initialValue={ currentCurrency.name }>
        //       <DropdownElement options={ currencyOptions }
        //                        loading={ loading }
        //                        disabled={ true }
        //                        withoutAll={ true }
        //                        showSearch={ false }
        //                        placeholder={ 'Currency*' }/>
        //     </Form.Item>
        //   </div>
        //   { hasChanges && <div className="body-item">
        //     <CustomButton onClick={ saveChanges }>Save</CustomButton>
        //   </div> }
        // </Form>
        <div className="app-currency--body business--body-items">
          <div className="body-item chips-body-item">
            { currentCurrency.symbol }{ currentCurrency.name }
          </div>
        </div>
      }
    </div>
  );
}
